import script from "./AdminReportsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReportsCard.vue?vue&type=script&setup=true&lang=js"

import "./AdminReportsCard.vue?vue&type=style&index=0&id=12a67dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a67dfa"]])

export default __exports__